import { createFileRoute } from '@tanstack/react-router';
import { PurchasePage } from '@/components/purchases/purchase-page';

export const Route = createFileRoute('/expenses/purchase-orders/$documentId')({ component: View });

/** Screen E10 (document 06): a purchase order, with Copy to bill and Close. */
function View() {
  const { documentId } = Route.useParams();
  return <PurchasePage kind="purchase_order" id={documentId} />;
}
